import { Observable } from "rxjs";
import { suche } from "@progressive-development/politik-model";

import { ladeJahresListe } from "../../../common/artefakte/artefakt-lader.js";

/**
 * Die Drucksachen-Liste — das erste Artefakt, das die App liest. Das Muster
 * (Manifest + eine Datei je Jahr) liegt in `common/artefakte/artefakt-lader.ts`.
 */

/** Was die Liste hält: alle Einträge, dazu Umfang und Stand aus dem Manifest. */
export interface DrucksachenListe {
  manifest: suche.DrucksachenListeManifest;
  eintraege: suche.DrucksachenEintrag[];
}

export class ArtefaktService {
  public ladeDrucksachenListe(): Observable<DrucksachenListe> {
    return ladeJahresListe<suche.DrucksachenListeManifest, suche.DrucksachenEintrag>(
      suche.DRUCKSACHEN_LISTE_MANIFEST,
    );
  }
}

export const artefaktService = new ArtefaktService();
